import React, { FC, ReactElement, useState } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { localizeType } from '../../commonType';
import { States_US } from '../../util/States';
import { PIN } from '../../util/strings';
import withLocalization from '../hoc/withLocalization';
import './StateSelector.scss';

interface StateSelectorType {
  prospectState: string;
  offerSearchMode: string;
  onStateChange: (n: boolean) => void;
  localize: localizeType;
  customerExcludedStateCode: string;
}

const StateSelector: FC<StateSelectorType> = (props: StateSelectorType): ReactElement => {
  const { prospectState, offerSearchMode, onStateChange, localize, customerExcludedStateCode } = props;
  const isPinSearch: boolean = offerSearchMode === PIN;
  const stateTitle = localize('preview-sales-engine.static-content.copy.eligibility-page.select-state-default');
  let prospectStateName: string = isPinSearch
    ? customerExcludedStateCode
      ? customerExcludedStateCode
      : prospectState
    : customerExcludedStateCode;
  const hasProspectState = prospectStateName && prospectStateName.length > 0;
  prospectStateName = hasProspectState
    ? prospectStateName.length > 2
      ? prospectStateName
      : States_US.filter((e) => e.code === prospectStateName)[0].name
    : '';
  const [value, setValue] = useState(hasProspectState ? prospectStateName : stateTitle);

  const handleSelect = (e) => {
    setValue(e);
    if (onStateChange && e !== stateTitle) {
      onStateChange(e);
    }
  };
  return (
    <>
      <div className="row stateSelectorWrapper">
        <div className="col-sm-4">
          <p>{localize('preview-sales-engine.static-content.copy.eligibility-page.where-do-you-live')}</p>
        </div>
        <div className="col-sm-8">
          <DropdownButton
            id="dropdown-item-button"
            title={value}
            onSelect={handleSelect}
            disabled={true}
          ></DropdownButton>
        </div>
      </div>
    </>
  );
};
export default React.memo(withLocalization(StateSelector));
